// extracted by mini-css-extract-plugin
var _1 = "InvestmentAgreementAppStyle-module__broker-agreement-app___TCIoY";
var _2 = "InvestmentAgreementAppStyle-module__broker-agreement-app___TCIoY";
export { _1 as "broker-agreement-app", _2 as "brokerAgreementApp" }
